module.exports = __webpack_public_path__ + "img/ATRC Platform - Website TCs-10.c046f4a7.png";